import React, { useState, useEffect } from "react";
import "./App.css";
import Spinner from "./Spinner";
import qbank from "./data/qbank";
import "./assets/css/bootstrap.min.css";
import "./assets/css/materialdesignicons.min.css";
import "./assets/css/tobii.min.css";
import "./assets/css/tiny-slider.css";
import "./assets/css/animate.css";
import "./assets/css/animations-delay.css";
import "./assets/css/style.css";
import "./assets/css/default.css";
import logo from "./assets/images/logopp.png";
import Classroom from "./assets/images/Classroom-Management.jpg";
import Header from "./components/Layouts/Header";
import Hero from "./components/Home/Hero";
import Thankyou from "./components/Home/Thankyou";
import GetStarted from "./components/Home/GetStarted";
import Questions from "./components/Home/Questions";
import { MdArrowForward, MdThumbUpOffAlt } from "react-icons/md";

//select 5 questions
const questions = ((qbank) => {
  const selectedQuestions = [];
  while (selectedQuestions.length < 5) {
    const randomIndex = Math.floor(Math.random() * qbank.length);
    if (!selectedQuestions.includes(qbank[randomIndex])) {
      selectedQuestions.push(qbank[randomIndex]);
    }
  }
  return selectedQuestions;
})(qbank);

const App = () => {
  const [text, setText] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [resultCard, setResultCard] = useState([]);
  const [quizFinished, setQuizFinished] = useState(false);
  const [quizStart, setQuizStart] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await fetch("/api", {
        method: "POST",
        body: JSON.stringify({
          question: questions[currentQuestion].question,
          studentAnswer: text,
          correctAnswer: questions[currentQuestion].answer,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error(res.statusText);
      }

      const data = await res.json();
      setIsLoading(false);

      setResultCard((prevResultCard) => [
        ...prevResultCard,
        {
          qno: currentQuestion + 1,
          question: questions[currentQuestion].question,
          studentAnswer: text,
          suggestion: data.message,
        },
      ]);

      if (currentQuestion === questions.length - 1) {
        setQuizFinished(true);
        return;
      }

      setCurrentQuestion((prevCurrentQuetions) => prevCurrentQuetions + 1);
      setText("");
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div>
      <Header />
      <Hero />
      {quizFinished ? (
        <div
          className="container mt-5 mb-5 d-flex justify-content-center align-items-center"
          id="start"
        >
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="text-center">
                <div
                  className="icon d-flex align-items-center justify-content-center bg-soft-primary rounded-circle mx-auto"
                  style={{ height: "90px", width: "90px" }}
                >
                  <MdThumbUpOffAlt className=" align-middle h1 mb-0" />
                </div>
                <h1 className="my-4 fw-bold">Result</h1>
                <p className="text-muted para-desc mx-auto">
                  Here is your test result.
                </p>
                {resultCard.map((item, i) => (
                  <div
                    className="card event-schedule rounded border mb-2"
                    key={i}
                  >
                    <div className="card-body">
                      <div className="d-flex">
                        <ul className="date text-center text-primary me-3 mb-0 list-unstyled">
                          <li className="day fw-bold mb-2">{i + 1}</li>
                        </ul>
                        <div className="flex-1 content">
                          <h4>
                            <a className="text-dark title"> {item.question}</a>
                          </h4>
                          <p className="text-muted ">
                            <span className="text-dark h6">Answer:</span>{" "}
                            {item.studentAnswer}
                            <br />
                            <span className="text-dark h6">
                              Suggestion:
                            </span>{" "}
                            {item.suggestion}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}
        </div>
      ) : quizStart ? (
        <section className="section bg-light" style={{ height: "80vh" }}>
          <div className="container mt-5 mb-5">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <div className="section-title mb-4 pb-2">
                  <h4 className="title mb-4">
                    Please answer the following questions
                  </h4>
                  <p className="para-desc mx-auto mb-0">
                    {currentQuestion + 1}. {questions[currentQuestion].question}
                  </p>
                  <form onSubmit={handleSubmit}>
                    <div className="form-icon position-relative">
                      <textarea
                        value={text}
                        name="textbody"
                        rows={4}
                        className="form-control mt-4 para-desc mx-auto mb-0"
                        placeholder="Your Answer :"
                        onChange={(e) => setText(e.target.value)}
                      />
                    </div>
                    <div className="row mt-4">
                      <div className="col-sm-12 para-desc mx-auto text-right d-flex justify-content-end pe-0">
                        <button
                          type="submit"
                          id="submit"
                          name="send"
                          disabled={isLoading}
                          className="btn btn-primary d-flex align-items-center"
                          defaultValue="Send Message"
                        >
                          Next {!isLoading ? <MdArrowForward /> : <Spinner />}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <GetStarted quizStarterHandler={() => setQuizStart(true)} />
      )}
    </div>
  );
};

export default App;
